import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/ai-disclaimer")({
  head: () => ({
    meta: [
      { title: "ClaimGuard | AI Disclaimer" },
      {
        name: "description",
        content:
          "How ClaimGuard uses AI to review invoices, what to expect from AI-generated findings, and how to use them responsibly.",
      },
      { property: "og:title", content: "ClaimGuard | AI Disclaimer" },
      {
        property: "og:description",
        content: "How we use AI in reviews, and what to expect from AI-generated findings.",
      },
      { name: "robots", content: "index,follow" },
      { property: "og:url", content: "https://smart-invoice-ally.lovable.app/ai-disclaimer" },
    ],
    links: [{ rel: "canonical", href: "https://smart-invoice-ally.lovable.app/ai-disclaimer" }],
  }),
  component: AiDisclaimerPage,
});

function AiDisclaimerPage() {
  return (
    <LegalPage
      eyebrow="Transparency"
      title="AI Disclaimer"
      updated="July 5, 2026"
      intro="ClaimGuard uses AI systems to read invoices, compare charges against public benchmarks, and draft findings. This page explains what AI does in our platform and how to interpret AI-assisted output."
      sections={[
        {
          heading: "What AI does in our platform",
          body: (
            <>
              <p>AI supports several steps in a review, including:</p>
              <ul className="list-disc pl-5">
                <li>Extracting text and line items from uploaded invoices.</li>
                <li>Categorizing charges and flagging potential issues.</li>
                <li>Comparing amounts against market benchmarks and public data.</li>
                <li>Drafting narrative explanations for the findings report.</li>
              </ul>
            </>
          ),
        },
        {
          heading: "AI is a tool, not a decision-maker",
          body: (
            <p>
              AI-generated findings are informational. They can occasionally miss context,
              misread values, or reflect limitations of the underlying data. You are the
              decision-maker on how to use the findings, including whether to dispute a
              charge, request a refund, or seek professional advice.
            </p>
          ),
        },
        {
          heading: "Human oversight",
          body: (
            <p>
              For Full-Service Negotiation, a human specialist reviews the AI output before any
              vendor communication is sent on your behalf. For Professional AI Review
              Review, output is delivered directly to you; if a finding looks incorrect,
              please contact support so we can improve accuracy.
            </p>
          ),
        },
        {
          heading: "Not legal, medical, or financial advice",
          body: (
            <p>
              Findings do not constitute legal, medical, tax, or financial advice. If your
              situation calls for professional advice, please consult an appropriately
              licensed professional.
            </p>
          ),
        },
        {
          heading: "Data used to train models",
          body: (
            <p>
              We do not use your invoices to train third-party foundation models. Content
              you upload is processed to deliver the services you requested.
            </p>
          ),
        },
      ]}
    />
  );
}
